import getFulfillmentOptions from 'services/api/upfunnel/getFulfillmentOptions';

export default { getFulfillmentOptions };
